import { useNavigate } from 'react-router'
import { useSnackbar } from 'notistack'

import { useActivationContext } from '../../providers/activation-provider'
import Api from '../../utils/api'

const useActivateFolder = () => {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const { activationLocationState } = useActivationContext()
  const { folderId } = activationLocationState

  const activateFolder = async (nodeId: number) => {
    if (!folderId) return
    try {
      // Get all the devices in the folder and check if all of them are activated
      const res = await Api.get(`/api/v2/protect/folders/${folderId}/device-activation-check`)
      if (!res.ok) throw new Error(res.statusText) // Throw error to the catch block
      const resDevices = res.body.devices as ICanActivateDeviceResponse[]
      // Count the number of devices that are not activated; if there aren't any, we can activate the folder
      const notActivatedDevicesCount = resDevices.reduce((count, device) => {
        if (device.totalDevicesNotInstalled > 0) {
          return count + device.totalDevicesNotInstalled
        }
        return count
      }, 0)
      // If all devices are activated, activate the folder
      if (notActivatedDevicesCount === 0) {
        const resActivation = await Api.post(`/api/v2/protect/folders/${folderId}/activation`, {})
        if (!resActivation.ok) {
          enqueueSnackbar('Could not activate folder.', { variant: 'error' })
        }
      }
      navigate('/complete-setup', { state: { ...activationLocationState, nodeId } })
    } catch {
      enqueueSnackbar('Could not check folder activation status.', { variant: 'error' })
    }
  }

  return { activateFolder }
}

export default useActivateFolder
